// Shared phone-breakpoint hook — same 640px cutoff App.jsx uses for the
// sidebar-vs-drawer switch, so screens with their own master-detail layout
// (Patient Records, Billing) switch to single-pane mode at the same point
// the rest of the chrome does.
import { useState, useEffect } from 'react';

const PHONE_BP = 640;

export function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(() => window.innerWidth < PHONE_BP);
  useEffect(() => {
    const onResize = () => setIsPhone(window.innerWidth < PHONE_BP);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isPhone;
}

export default useIsPhone;
